export default "__VITE_ASSET__XkN$DftD__"